import i18n from 'i18next';
import {initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
i18n
.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    backend: {
        loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
        // Translations are fetched at runtime, so a release that adds a key
        // does not invalidate them the way a bundled file would — the browser
        // keeps answering from its own copy and the new labels stay in English
        // until the cache entry expires. Revalidating asks the server every
        // time and still costs nothing when nothing changed, since an
        // unmodified file comes back as a 304 with no body.
        requestOptions: { cache: 'no-cache' },
    },
    debug: false,
    lng: localStorage.getItem("i18nextLng") || "en",
    ns: ["main", "orders", "purchasedHistory"],
    defaultNS: "main",
    interpolation: {
        formatSeparator: ',',
    },
    react: {
        useSuspense: false
    }
});